<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadUser="loadUser"
      @loadSummary="loadSummary"
      @loadPresentation="loadPresentation"
      :includeAdmin="true"
    ></results-bar>
    <results-summary
      :id="doc.id"
      v-if="summaryMode === 'summary'"
    ></results-summary>
    <results-presentation
      :id="doc.id"
      v-if="summaryMode === 'presentation'"
    ></results-presentation>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  ResultsSummary,
  ResultsBar,
  ResultsPresentation,
} from "@/components/results/personas";

export default {
  name: "Personaresults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "summary",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsSummary,
    ResultsBar,
    ResultsPresentation,
  },
  computed: {
    ...mapState(["exPersonas"]),
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
    },
    loadPresentation(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
    },
    loadUser(uid, mode) {
      this.currentUser = uid;
      this.summaryMode = mode;
    },
  },
};
</script>
